"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathWalletConnector = void 0;
const MetamaskConnector_1 = require("./MetamaskConnector");
const Types_1 = require("../../Types");
class MathWalletConnector extends MetamaskConnector_1.MetamaskConnector {
    constructor(blockchainConfig) {
        super(blockchainConfig, {
            name: Types_1.WalletConnectors.MathWallet,
            displayName: "Mathwallet",
            isWallet: true,
        });
    }
    async _connect() {
        return super._connect();
    }
    async isAvailable() {
        return !!this.getAgent() && this.getAgent().isMathWallet;
    }
    getAgent() {
        return this.config.blockchain === Types_1.Blockchains.Harmony
            ? window.harmony
            : window.ethereum;
    }
}
exports.MathWalletConnector = MathWalletConnector;
